import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
//import { bootstrapApplication } from '@angular/platform-browser';
import { AppModule, HttpLoaderFactory } from './app/app.module';
import { environment } from './environments/environment';

import moment from 'moment';
import { UserService } from './app/shared/user.service';
import { TeamService } from './app/shared/team.service';
import { AuthGuard } from './app/auth/auth.guard';
import { Globals } from './app/globals';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { AuthInterceptor } from './app/auth/auth.interceptor';
import { TimeZoneInterceptor } from './app/interceptors/timezone/timezoneinterceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MomentModule } from 'ngx-moment';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatTreeModule } from '@angular/material/tree';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { LayoutModule } from '@angular/cdk/layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilesModule } from './app/profiles/profiles.module';
import { TestResultModule } from './app/test-result/test-result.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { AppConfigurationModule } from './app/app-configuration/app-configuration.module';
import { AppComponent } from './app/app.component';

//enableProdMode();
if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }), BrowserModule,
            /* RankingListRoutingModule, */
            AppRoutingModule, MomentModule, MatGridListModule, MatCardModule, MatMenuModule, MatIconModule, MatButtonModule, MatSidenavModule, MatListModule, MatToolbarModule, MatDialogModule, MatFormFieldModule, MatOptionModule, MatSelectModule, MatInputModule, MatTreeModule, MatPaginatorModule, MatExpansionModule, MatSortModule, MatTableModule, MatCheckboxModule, MatAutocompleteModule, MatButtonToggleModule, MatDatepickerModule, MatProgressBarModule, MatChipsModule, MatRippleModule, MatRadioModule, MatProgressSpinnerModule, MatSlideToggleModule, MatSliderModule, LayoutModule, FormsModule, ReactiveFormsModule,
            /*     RxReactiveFormsModule, */
            ProfilesModule, TestResultModule, DragDropModule, MatTabsModule, MatBadgeModule, MatDatepickerModule, MatMomentDateModule, AppConfigurationModule),
        UserService, TeamService,
        //TestResultService,
        AuthGuard, Globals,
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TimeZoneInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
})
    .catch(err => console.error(err)); 

/* bootstrapApplication(AppModule, appConfig)
.catch((err) => console.error(err)); */
